
import './App.css';
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useAuth } from './context/AuthContext.js';
import RequireAuth from './context/RequireAuth.js';

import Home from './pages/Home.js'
import Pref from './pages/Pref.js'
import History from './pages/History.js'
import Error from './pages/Error.js'
import Help from './pages/Help.js'
import Ready from './pages/Ready.js'
import Registered from './pages/Registered.js'

import Authent from './auth/Authent.js'
import Logout from './auth/Logout.js'
import Login from './auth/Login.js'
import ProtectedRoute from './auth/ProtectedRoute.js';

import Game from './components/Game.js'

function App() {
  const [currentUser, setCurrentUser] = useState(useAuth());
  const [menu, setMenu] = useState();

  // Load menu
  useEffect(() => {
    async function getMenu () {
      if (currentUser !== null) {
        setMenu (
          <nav>
            <Link to="/">Home</Link> |{" "}
            <Link to="/prefs">Préférences</Link> |{" "}
            <Link to="/game/maxword" className='jouer'>Jeu</Link> |{" "}
            <Link to="/history">Scores</Link> |{" "}
            <Link to="/logout">Logout</Link> |{" "}
            <Link to="/help">?</Link>
          </nav>
        );
      } else {
        setMenu (
          <nav>
            <Link to="/authent/register">Inscription</Link> |{" "}
            <Link to="/authent/login">Login</Link>
          </nav>
        );
      }
    }
    getMenu ();
  }, [currentUser]);

  return (
      <RequireAuth>
        <HashRouter>
          <div className="menu">{menu}</div>
          
          <div className="App">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/prefs" element={
                <ProtectedRoute currentUser={currentUser}>
                  <Pref />
                </ProtectedRoute>
              } />
              <Route path="/game/:mode" element={<ProtectedRoute currentUser={currentUser}>
                  <Game />
                </ProtectedRoute>
              } />
              <Route path="/history" element={<ProtectedRoute currentUser={currentUser}>
                  <History />
                </ProtectedRoute>
              } />
              <Route path="/logout" element={
                <ProtectedRoute currentUser={currentUser}>
                  <Logout setCurrentUser={setCurrentUser} />
                </ProtectedRoute>
              } />
              <Route path="/help" element={
                <ProtectedRoute currentUser={currentUser}>
                  <Help setCurrentUser={setCurrentUser} />
                </ProtectedRoute>
              } />
            
              <Route path="/login" element={<Login setCurrentUser={setCurrentUser} />} />
              <Route path="/authent/:type" element={<Authent setCurrentUser={setCurrentUser} />} />
              <Route path="/registered" element={<Registered setCurrentUser={setCurrentUser} />} />
              <Route path="/ready2play" element={<Ready setCurrentUser={setCurrentUser} />} />
              <Route path="*" element={<Error />} />
            </Routes>
          </div>
        </HashRouter>

        <div className="App">
          <ToastContainer />
        </div>
      </RequireAuth>
  );
}

export default App;